import { Component, OnInit, HostListener, OnDestroy } from '@angular/core';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { Vehicle } from '../../shared/models/vehicle';
import { year } from '../../shared/models/model-year';
import { AdminService } from '../admin.service';
import { ManageVehicleService } from '../manage-vehicle/manage-vehicle.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { ConfirmModalComponent } from '../../shared/components/confirm-modal/confirm-modal.component';
import { Observable } from 'rxjs';
import { TCCPConstantValues } from '../../shared/models/tccp-constants'
import { TCCPLocalStorageService } from 'src/modules/shared/services/tccp-local-storage.service';
import { TCCPCommonService } from '../../shared/services/tccp-common.service';
import _ from 'lodash';

@Component({
  selector: 'app-add-vehicle',
  templateUrl: './add-vehicle.component.html',
  styleUrls: ['./add-vehicle.component.scss']
})

export class AddVehicleComponent implements OnInit {
  public pageTitle = 'Add Vehicle';
  public dropdownList = [];
  public selectedFeatures = [];
  public featureList = [];
  public internalFeatureList = [];
  public externalFeatureList = [];
  public selectedItems = [];
  public dropdownSettings: IDropdownSettings;
  public vehicle: Vehicle = < Vehicle > ({ model: null, classification: null, years: [], order: null, modelCodes: [] });
  public showExisting = false ;
  public year: year;
  public alerts: any[] = [];
  public features: any[];
  public showError = false ;
  public isViewMode = false ;
  public isAddMode = false ;
  public isEditMode = false ;
  public preVehicle: any = {};
  public preYear: any = {};
  public classifications: string[];
  public existingModels: any[];
  public existingYears: string[];
  public existingModel: string;
  public existingYear: number;
  public subscribeEvent: any;
  public models: any[];

  constructor(
    public commonService: TCCPCommonService, private adminService: AdminService, private vehicleService: ManageVehicleService,
    private dialog: MatDialog, private router: Router, private storageService: TCCPLocalStorageService, private translate: TranslateService) { }

  ngOnInit() {
    this.vehicle = < Vehicle > ({ model: null, classification: null, years: [], order: null, modelCodes: [] });
    this.year = < year > ({ year: null, generation: null, controls: [], features: [] });
    this.isAddMode = true;
    this.isEditMode = false ;
    this.isViewMode = false ;
    this.storageService.setSwitchApp(false );
    if (this.adminService.selectedApplication.toLowerCase() === 'toyota') {
      this.classifications = ['CARS & MINIVAN', 'CROSSOVERS & SUVS', 'HYBRIDS & FUEL CELL', 'TRUCKS'];
    }

    if (this.adminService.selectedApplication.toLowerCase() === 'lexus') {
      this.classifications = ['COUPES/CONVERTIBLES', 'HYBRIDS', 'PERFORMANCE', 'SEDANS', 'SUVS'];
    }
    if (!this.vehicleService.vehicle) {
      this.vehicleService.getmodel().subscribe(data => {
        this.models = data;
      });
    }
    if (this.vehicleService.vehicle) {
      this.vehicle = this.vehicleService.vehicle;
      this.pageTitle = 'Edit Vehicle';
      this.isEditMode = true;
      this.isAddMode = false ;
      this.isViewMode = false ;
    }

    if (this.vehicleService.vehicle && this.vehicleService.vehicleYear) {
      this.year = this.vehicleService.vehicle.years.filter(x => x.year === this.vehicleService.vehicleYear)[0];
      this.vehicleService.vehicle = null;
    }

    this.adminService.getFlow().subscribe((data: any) => {
      data.forEach(control => {
        control.controls.forEach(obj => {
          this.featureList = this.featureList.concat({
            issueId: control.issueId, featureName: obj.featureName,
            featureType: control.featureType
          });
          if (control.featureType === 'internal') {
            this.internalFeatureList = this.internalFeatureList.concat({
              issueId: control.issueId, featureName: obj.featureName,
              featureType: control.featureType
            });
          } else {
            this.externalFeatureList = this.externalFeatureList.concat({
              issueId: control.issueId, featureName: obj.featureName,
              featureType: control.featureType
            });
          }
          this.dropdownList = this.dropdownList.concat({
            issueId: control.issueId,
            featureName: obj.featureName + ' - ' + control.featureType, featureType: control.featureType
          });

        });
      });
      if (this.year.features && this.year.features.length > 0) {
        this.year.features.forEach(element => {
          this.selectedFeatures.push(this.dropdownList.filter(x => x.issueId === element)[0]);
        });
        let result: any = [];
        result = this.dropdownList.filter(x => !this.selectedFeatures.some(y => x.issueId === y.issueId));
        this.dropdownList = this.selectedFeatures.concat(result);
      }
      this.preVehicle = Object.assign({}, this.vehicle);
      this.preYear = Object.assign({}, this.year);
      this.vehicleService.features = this.dropdownList;
      this.getModel();
    });

    this.dropdownSettings = {
      singleSelection: false ,
      idField: 'issueId',
      textField: 'featureName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true
    };

    this.vehicleService.refreshFeatures.subscribe(data => {
      if (data) {
        this.year.features = data;
        this.year.features = this.year.features.slice();
      }
    });

    this.subscribeEvent = this.adminService.editModeNavigation.subscribe(data => {
      if (data) {
        this.canDeactivate();
      }
    });

  }

  showExistingChange() {
    this.existingModel = '';
    this.existingYear = null;
  }
  supportTopicChange(event) {
  }

  changeOrder(control, direction, itemIndex, featureType) {
    let haveSwapped = false ;
    let swappingIndex; let swapItem2;
    const spList = [];
    const tempSPList = featureType === 'internal' ? this.internalFeatureList : this.externalFeatureList;
    this.year.features.forEach(x => {
      tempSPList.forEach(y => {
        if (x === y.issueId) {
          spList.push(y);
        }
      });
    });
    const swapItem1 = spList.find(x => x.issueId === control.issueId);
    const swapIndex1 = spList.findIndex(x => x.issueId === control.issueId);
    if (direction === 'up') {
      swappingIndex = swapIndex1 < 1 ? spList.length - 1 : swapIndex1 - 1;
    } else {
      swappingIndex = swapIndex1 === spList.length - 1 ? 0 : swapIndex1 + 1;
    }
    if (!haveSwapped) {
      swapItem2 = spList[swappingIndex];
      const yearSwapItem1 = this.year.features.find(x => x === swapItem1.issueId);
      const yearSwapItem2 = this.year.features.find(x => x === swapItem2.issueId);
      const yearSwapIndex1 = this.year.features.findIndex(x => x === swapItem1.issueId);
      const yearSwapIndex2 = this.year.features.findIndex(x => x === swapItem2.issueId);
      this.year.features[yearSwapIndex1] = yearSwapItem2;
      this.year.features[yearSwapIndex2] = yearSwapItem1;
      haveSwapped = true;
    }
  }

  removeControl(control) {
    if (this.year.features && this.year.features.length > 0) {
      this.year.features.forEach((obj, index) => {
        if (obj === control.issueId) {
          this.year.features.splice(index, 1);
        }
      });
    }
    this.year.features = this.year.features.slice();
  }

  editView() {
    this.alerts = [];
    this.pageTitle = 'Edit Vehicle';
    this.isAddMode = false ;
    this.isEditMode = true;
    this.isViewMode = false ;
  }

  mandatoryCheck() {
    let isValid = false ;
    if (this.year.year && !this.year.year.toString().match(/^\d{4}$/)) {
      return false ;
    }

    if (!_.isEmpty(this.vehicle.modelCodes) && !this.vehicle.modelCodes.toString().match(/^[0-9\n,.-]*$/)) {
      return false ;
    }

    if (this.vehicle.model && this.vehicle.classification && this.vehicle.years && this.year.generation &&
      !_.isEmpty(this.vehicle.modelCodes)) {
      isValid = true;
    }
    return isValid;
  }

  notEmpty< TValue >(value: TValue | null | undefined): value is TValue {
    return value !== null && value !== undefined;
  }

  onSave() {
    this.alerts = [];
    this.showError = true;
    if (this.mandatoryCheck()) {
      this.showExisting = false ;
      this.existingModel = '';
      this.existingYear = null;
      this.vehicle.model = this.vehicle.model.trimLeft().trimRight();
      this.vehicle.modelCodes = this.vehicle.modelCodes.toString().trim().split(',');
      if (this.year.features) {
        this.year.features = this.year.features.filter(this.notEmpty);
        this.selectedFeatures = [];
        this.year.features.forEach(element => {
          if (this.dropdownList.filter(x => x.issueId === element)[0] !== undefined) {
            this.selectedFeatures.push(this.dropdownList.filter(x => x.issueId === element)[0]);
          }
        });
        let result: any = [];
        result = this.dropdownList.filter(x => !this.selectedFeatures.some(y => x.issueId === y.issueId));
        this.dropdownList = this.selectedFeatures.concat(result);
      }
      this.vehicleService.getVehicle(this.vehicle.model).subscribe((data: Vehicle) => {
        if (data == null) {
          if (this.year.year) {
            this.vehicle.years.push(this.year);
          } else {
            this.vehicle.years = [];
          }
          console.log('this.vehicle request', this.vehicle);
          console.log('this.vehicle json', JSON.stringify(this.vehicle))
          this.vehicleService.createVehicle(this.vehicle).subscribe(response => {
            if (response) {
              const message = this.vehicle.model + ' ' + this.year.year + ' is successfully saved';
              this.showAlertMessages('success', message);
              // const requestParmeter;
              /* this.adminService.createCategoryMapping(this.adminService.selectedApplication).subscribe(categoryMappingResponse => {
                if (categoryMappingResponse) {
                  console.log('categoryMappingResponse', categoryMappingResponse);
                }
              }); */
              // order implementation of Category
              this.pageTitle = 'View Vehicle';
              this.isViewMode = true;
              this.isEditMode = false ;
              this.isAddMode = false ;
            }
          });
        } else {
          const vech = data.years.filter(x => x.year === this.year.year)[0];
          if (vech) {
            if (this.isAddMode) {
              this.showAlertMessages('error', 'Vehicle Model and Year already exists');
            } else {
              const index = data.years.indexOf(vech);
              vech['generation'] = this.year.generation;
              if (this.year.features) {
                vech['features'] = this.year.features;
              } else {
                vech['features'] = [];
              }
              data.years[index] = vech;
              console.log('vech', data);
              data.classification = this.vehicle.classification;
              data.modelCodes = this.vehicle.modelCodes.toString().split(',');
              console.log('this.vehicle update request', this.vehicle);
              this.vehicleService.updateVehicle(data).subscribe(response => {
                const message = this.vehicle.model + ' ' + this.year.year + ' is successfully updated';
                this.showAlertMessages('success', message);
                this.pageTitle = 'View Vehicle';
                this.isViewMode = true;
                this.isEditMode = false ;
                this.isAddMode = false ;
              });
              this.storageService.setCachedVehicles([]);
              this.storageService.setCachedFeatures([]);
            }
          } else {
            data.years.push(this.year);
            console.log('vech else', data);
            this.vehicleService.updateVehicle(data).subscribe(response => {
              const message = this.vehicle.model + ' ' + this.year.year + ' is successfully saved';
              this.showAlertMessages('success', message);
              this.pageTitle = 'View Vehicle';
              this.isViewMode = true;
              this.isEditMode = false ;
              this.isAddMode = false ;
            });
            this.storageService.setCachedVehicles([]);
            this.storageService.setCachedFeatures([]);
          }
        }
      });
    }
  }

  onCancel() {
    this.alerts = [];
    const dialogRef = this.dialog.open(ConfirmModalComponent, {
      width: '350px',
      data: TCCPConstantValues.admin.messages.LOST_UNSAVED_MESSAGE,
      position: { top: '100px' },
      id: 'admin-' + this.adminService.selectedApplication
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.showExisting = false ;
        this.existingModel = '';
        this.existingYear = null;
        const initialInfo1 = Object.assign({}, this.preVehicle);
        const initialInfo2 = Object.assign({}, this.preYear);
        this.vehicle = initialInfo1;
        this.year = initialInfo2;
        this.year.features = this.year.features.slice();
        this.isViewMode = true;
        this.isEditMode = false ;
        this.isAddMode = false ;
        if (this.vehicle.model === null) {
          this.router.navigateByUrl('admin/vehicle');
        }
      }
    });
  }

  customCompare(c1, c2) {
    return c1 && c2 ? c1.id === c2.id : c1 === c2;
  }
  public showAlertMessages(messageType, message) {
    this.alerts = [];
    if (this.alerts.length === 0) {
      this.alerts.push({
        type: messageType,
        msg: message
      });
    }
    window.scroll(0, 0);
  }

  closeAlerts() {
    this.alerts = [];
  }

  onModelChange(event) {
    this.getVehicleYear(event.value);
  }

  getVehicleYear(model: string) {
    this.vehicleService.getyear(model)
      .subscribe(data => {
        this.existingYears = data;
      });
  }

  getVehicleFeature(model: string, yearParam: number) {
    this.vehicleService.getFeature(model, yearParam)
      .subscribe(data => {
        this.year.features = data.years.filter(x => x.year === yearParam)[0].features;
      });
  }

  getModel() {
    this.vehicleService.getmodel().subscribe((data: any) => {
      this.existingModels = data;
    });
  }

  onFeatureCopy() {
    if (this.year.features.length > 0) {
      const dialogRef = this.dialog.open(ConfirmModalComponent, {
        width: '350px',
        data: 'The added features will be lost and overridden. Continue?',
        position: { top: '100px' },
        id: 'admin-' + this.adminService.selectedApplication
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.getVehicleFeature(this.existingModel, this.existingYear);
          this.existingModel = null;
          this.existingYear = null;
        }
      });
    } else {
      this.getVehicleFeature(this.existingModel, this.existingYear);
      this.existingModel = null;
      this.existingYear = null;
    }
  }

  openVehicleDialog() {
    const dialogRef = this.dialog.open(AddVehicleDialogComponent, {
      width: '400px'

    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  openConfirmDialog(item): void {
    const dialogRef = this.dialog.open(ConfirmModalComponent, {
      width: '350px',
      data: 'Are you sure you want to delete the Feature?',
      position: { top: '100px' },
      id: 'admin-' + this.adminService.selectedApplication
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.removeControl(item);
      }
    });
  }

  @HostListener('window:beforeunload')
  canDeactivate(): Observable< boolean > | boolean {
    if (this.isEditMode || this.isAddMode && (!this.storageService.getSwitchApp())) {
      if (JSON.stringify(this.vehicle) !== JSON.stringify(this.preVehicle) || JSON.stringify(this.year) !== JSON.stringify(this.preYear)) {
        const dialogRef = this.dialog.open(ConfirmModalComponent, {
          width: '350px',
          data: TCCPConstantValues.admin.messages.LOST_UNSAVED_MESSAGE,
          position: { top: '100px' },
          id: 'admin-' + this.adminService.selectedApplication
        });
        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            this.adminService.editModeNavigation.emit(false );
          }
        });
        return dialogRef.afterClosed();
      } else {
        return true;
      }
    } else {

      return true;
    }
  }

  ngOnDestroy() {
    if (this.subscribeEvent) {
      this.subscribeEvent.unsubscribe();
    }
  }

}

@Component({
  selector: 'app-add-vehicle-dialog-component',
  templateUrl: './add-vehicle-dialog.componenet.html',
  styleUrls: ['./add-vehicle.component.scss']

})
export class AddVehicleDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<AddVehicleComponent>,
    private vehicleService: ManageVehicleService) {
  }

  public models: any[];
  public years: string[];
  public model: string;
  public year: number;
  public features: year;
  public featuresList = [];

  ngOnInit() {
    this.vehicleService.getmodel().subscribe((data: any) => {
      this.models = data;
    });
    this.featuresList = this.vehicleService.features;
  }

  close(): void {
    this.dialogRef.close();
  }

  onModelChange(event) {
    this.getVehicleYear(event.value);
  }

  getVehicleYear(model: string) {
    this.vehicleService.getyear(model)
      .subscribe(data => {
        this.years = data;
      });
  }

  onYearChange() {
    this.getVehicleFeature(this.model, this.year);
  }

  getVehicleFeature(model: string, yearParam: number) {
    this.vehicleService.getFeature(model, yearParam)
      .subscribe(data => {
        this.features = data.years.filter(x => x.year === yearParam)[0].features;
      });
  }

  onCancel() {
    this.model = null;
    this.year = null;
    this.features = null;
  }

  onSelect() {
    this.vehicleService.refreshFeatures.emit(this.features);
    this.dialogRef.close();
  }

}








